export default defineNuxtPlugin(() => {
    document.addEventListener(
        'click',
        event => {
            const target = event.target;

            if (!(target instanceof Element)) {
                return;
            }

            const anchor = target.closest('a[href]');

            if (!(anchor instanceof HTMLAnchorElement)) {
                return;
            }

            const href = anchor.getAttribute('href') ?? '';
            const linkText = anchor.textContent?.trim() ?? '';

            if (href.startsWith('mailto:')) {
                trackContactEmailClick(href, linkText);
                return;
            }

            if (href.startsWith('tel:')) {
                trackContactPhoneClick(href, linkText);
            }
        },
        { capture: true }
    );
});
